import type { BoardStatusCategory } from "./use-boards";

// Keys, not text: what a category is called belongs to the screen showing it.
export const boardStatusCategories: Array<{ descriptionKey: string; id: BoardStatusCategory; labelKey: string }> = [
  { descriptionKey: "statuses.notStartedHint", id: "not_started", labelKey: "statuses.notStarted" },
  { descriptionKey: "statuses.activeHint", id: "active", labelKey: "statuses.active" },
  { descriptionKey: "statuses.doneHint", id: "done", labelKey: "statuses.done" },
  { descriptionKey: "statuses.closedHint", id: "closed", labelKey: "statuses.closed" },
];

export const boardStatusColorPresets = [
  "#64748b",
  "#6b7280",
  "#ef4444",
  "#f97316",
  "#f59e0b",
  "#eab308",
  "#22c55e",
  "#10b981",
  "#06b6d4",
  "#0ea5e9",
  "#6366f1",
  "#8b5cf6",
] as const;

export function defaultStatusColor(category: BoardStatusCategory) {
  if (category === "closed") {
    return "#22c55e";
  }
  if (category === "done") {
    return "#22c55e";
  }
  if (category === "active") {
    return "#0ea5e9";
  }
  return "#64748b";
}
